import clsx from 'clsx';
import { Building2, House } from 'lucide-react';
import type { WorkMode } from '../lib/api';
import { useI18n } from '../lib/i18n';

/** The office's icon and remote's: the Employees list, an employee's page and Working now. */
export const WORK_MODE_ICONS = { OFFICE: Building2, REMOTE: House } as const;

/**
 * Office or Remote, with its icon. An API from before the field sends none:
 * they are at the office, as the column's default makes everyone.
 */
export function WorkModeLabel({ mode, className }: { mode: WorkMode | null | undefined; className?: string }) {
  const { t } = useI18n();
  const value = mode ?? 'OFFICE';
  const Icon = WORK_MODE_ICONS[value];
  return (
    // align-middle: an inline-flex box sits on its icon's foot, a little above the row's other text.
    <span className={clsx('inline-flex items-center gap-1.5 whitespace-nowrap align-middle', className)}>
      <Icon className="h-4 w-4 shrink-0 self-center text-[var(--text-tertiary)]" aria-hidden />
      {t(`employees.workMode.${value}`)}
    </span>
  );
}
